<template>
    <div class="col-12 col-sm-11 col-md-9 col-lg-5">
        <div class="content traffic">
            <div class="h5 title">{{ $t('views.dashboard.sections.analytics_traffic.title') }}</div>
            <div v-if="loading" class="p description">{{ $t('views.dashboard.sections.analytics_traffic.description') }}</div>
            <LoadingSection v-if="loading" :showMessage="false" />
            <div v-if="!loading" class="stats-card">
                <div class="starts-card-content">
                    <div class="h2 value">{{ formatNumber(totalVisitors) }}</div>
                    <div class="p name">{{ $t('views.dashboard.sections.analytics_traffic.visitors') }}</div>
                </div>
            </div>
            <div v-if="!loading" class="p description">{{ $t('views.dashboard.sections.analytics_traffic.description') }}</div>
            <div v-if="!loading" class="p disclaimer">{{ $t('views.dashboard.sections.analytics_traffic.disclaimer') }}</div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'pinia';
    import { useAccountStore } from '@/stores/account';
    import { formatNumber } from '@/utils/formatting';
    import LoadingSection from '@/components/sections/LoadingSection';

    export default {
        name: "DashboardTraffic",
        components: {
            LoadingSection
        },
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState(useAccountStore, ['hasAccountStats', 'accountStats']),
            totalVisitors() {
                const matched = this.accountStats?.matched;
                if (!this.hasAccountStats || typeof matched !== 'object' || !matched) return 0;
                
                return Object.values(matched).reduce((sum, value) => sum + (value || 0), 0);
            }
        },
        methods: {
            formatNumber
        }
    }
</script>
